/*
 * @Author: 刘洪壮 liuhongzhuang@nextmar.com
 * @Date: 2025-06-16 10:37:07
 * @LastEditors: 刘洪壮 liuhongzhuang@nextmar.com
 * @LastEditTime: 2025-06-16 10:55:01
 * @FilePath: /zeelool-nextjs/src/app/(staitc-page)/guide-tips/modules/left-nav.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
'use client';

import { IS_DE } from '@/utils/constants';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import { CloseOutlined } from '@zeelool/icon';
import { useTranslations } from 'next-intl';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import * as React from 'react';

interface LeftNavProps {
  isMobile?: boolean;
}

type Anchor = 'top' | 'left' | 'bottom' | 'right';

export default function LeftNav({ isMobile }: LeftNavProps) {
  const t = useTranslations('guideTips.leftNav');
  const pathname = usePathname();

  const defaultItems = [
    {
      title: t('chooseEyeglasses'),
      link: '/guide-tips/choose-eyeglasses',
    },
    {
      title: t('fillOutPrescription'),
      link: '/guide-tips/fill-out-prescription',
    },
    {
      title: t('measurePD'),
      link: '/guide-tips/measure-PD',
    },
    {
      title: t('measureFrameSize'),
      link: '/guide-tips/frame-size',
    },
    {
      title: t('faceShape'),
      link: '/guide-tips/face-shape',
    },
    {
      title: t('lensesAndCoatings'),
      link: '/guide-tips/lenses-coating',
    },
    {
      title: t('bluelightProtectLens'),
      link: '/guide-tips/bluelight',
    },
    {
      title: t('adjustEyeglasses'),
      link: '/guide-tips/adjust',
    },
  ];

  // de 多点页面
  const DE_NAV_ITEMS = [
    {
      title: 'Selbsttönende Brillengläser',
      link: '/guide-tips/photochromic-lenses',
    },
    {
      title: 'Polarisierende Sonnenbrillengläser',
      link: '/guide-tips/polarized-lenses',
    },
  ];

  const navItems = [...defaultItems, ...(IS_DE ? DE_NAV_ITEMS : [])];

  // 根据当前路径计算应该显示的title
  const getCurrentTitle = () => {
    const currentItem = navItems.find((item) => item.link === pathname);
    return currentItem ? currentItem.title : navItems[0].title;
  };

  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const toggleDrawer =
    (anchor: Anchor, open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
      if (
        event.type === 'keydown' &&
        ((event as React.KeyboardEvent).key === 'Tab' ||
          (event as React.KeyboardEvent).key === 'Shift')
      ) {
        return;
      }

      setState({ ...state, [anchor]: open });
    };

  const list = (anchor: Anchor) => (
    <Box
      sx={{ width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 250 }}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <List>
        <div className="flex justify-end pr-8 pb-8">
          <CloseOutlined className="text-28" />
        </div>
        {navItems.map((item) => {
          const isCurrentPage = pathname === item.link;
          return (
            <ListItem key={item.link} className="border-t border-solid border-t-gray-300">
              {isCurrentPage ? (
                <ListItemText
                  primary={item.title}
                  className="font-br text-gray-400 cursor-default"
                />
              ) : (
                <Link prefetch={false} href={item.link}>
                  <ListItemText primary={item.title} className="font-br" />
                </Link>
              )}
            </ListItem>
          );
        })}
      </List>
    </Box>
  );

  return (
    <div className="md:w-[360px] md:pt-[61px] box-border text-left text-sm font-normal bg-[#F5F6F7]">
      {!isMobile && (
        <ul className="w-full">
          {navItems.map((item) => (
            <Link prefetch={false} href={item.link} key={item.link}>
              <li
                key={item.link}
                className={`h-[60px] pl-[56px] leading-[60px]  text-[#333] cursor-pointer hover:text-white hover:bg-primary-purple ${
                  pathname === item.link ? 'text-white bg-primary-purple' : ''
                }`}
              >
                {item.title}
              </li>
            </Link>
          ))}
        </ul>
      )}

      {isMobile && (
        <div className="w-full h-[65px]">
          <div className="flex items-center justify-between w-full p-16">
            <span className="text-16 font-br">{getCurrentTitle()}</span>
            {/* 蓝色加号图标 */}
            <div
              onClick={toggleDrawer('top', true)}
              className=" w-[30px] h-[30px] bg-[#3361db] rounded-[8px] flex items-center justify-center shadow-[1.333vw_1.867vw_5.6vw_0_rgba(51,97,219,0.45)]"
            >
              <div className="relative w-[12px] h-[12px]">
                {/* 垂直线 */}
                <div className="absolute left-1/2 top-1/2 w-[2px] h-[12px] bg-white transform -translate-x-1/2 -translate-y-1/2 " />
                {/* 水平线 */}
                <div className="absolute left-1/2 top-1/2 w-[12px] h-[2px] bg-white transform -translate-x-1/2 -translate-y-1/2" />
              </div>
            </div>
          </div>

          {(['top'] as const).map((anchor) => (
            <React.Fragment key={anchor}>
              <Drawer
                anchor={anchor}
                open={state[anchor]}
                onClose={toggleDrawer(anchor, false)}
                PaperProps={{
                  sx: {
                    width: '100vw',
                    height: '100vh',
                    maxWidth: 'none',
                    maxHeight: 'none',
                  },
                }}
              >
                {list(anchor)}
              </Drawer>
            </React.Fragment>
          ))}
        </div>
      )}
    </div>
  );
}
